import { createTypes } from "../../../utils/redux/create-types";

export default createTypes(
    `
    SET_BRAND
    SET_MODEL
    SET_YEAR
    SET_FUEL_TYPE
    SET_TRANSMISSION_TYPE
    SET_REGISTRATION_STATE
    SET_VARIANT
    SET_RTO
    SET_CURRENT_STEP
    ACTIVATE_LAST_STEP
    MAKE_LEAD
    MAKE_LEAD_SUCCESS
    MAKE_LEAD_FAILURE
    MERGE_LEAD_DATA
    SET_QUESTIONS_ARRAY
    SET_CURRENT_QUESTION_INDEX
    STORE_ANSWERED_QUESTION
    SET_SELECTED_DATE
    SET_SELECTED_TIME
    SET_LOCATION_NAME
    SET_TOKEN
    SET_KILOMETERS_DRIVEN
    SET_BASIC_DETAILS_COMPLETE
    RESET_QUESTIONS
    RESET_SELLONLINE_LEAD_FORM_DATA
`,
    {
        prefix: "sellOnlineLeadData/"
    }
);
